import React, { PropsWithChildren } from 'react';
import { ElementOrArrayOfElement } from '../common/Types';
import './Filters.css';

export interface DetailPaneContainerProps {
  children: ElementOrArrayOfElement<DetailPaneProps>;
}

type DetailPaneHeader = PropsWithChildren<{
  closeDetailPaneHandler?: () => void;
  attrs?: React.ButtonHTMLAttributes<HTMLDivElement>;
}>;
type DetailPaneBody = PropsWithChildren<{
  attrs?: React.ButtonHTMLAttributes<HTMLDivElement>;
}>;

type DetailPaneProps = PropsWithChildren<{
  detailPaneHeader: React.ReactElement;
  detailPaneBody: React.ReactElement;
  closeDetailPaneHandler?: () => void;
  rowKey: string;
}>;

export const DetailPaneHeader: React.FC<DetailPaneHeader> = props => {
  const { attrs, children } = props;
  return (
    <div className="datagrid-detail-header" {...attrs}>
      <div className="datagrid-detail-header-title">{children}</div>
      <div className="datagrid-detail-pane-close">
        <button className="btn btn-link" onClick={props.closeDetailPaneHandler}>
          <clr-icon class="close-button" shape="times" size="24" />
        </button>
      </div>
    </div>
  );
};

export const DetailPaneBody: React.FC<DetailPaneBody> = props => {
  const { attrs, children } = props;
  return (
    <div className="datagrid-detail-body">
      <div className="clr-dg-detail-body-wrapper" {...attrs}>
        {children}
      </div>
    </div>
  );
};

export const DetailPane: React.FC<DetailPaneProps> = props => {
  const { detailPaneHeader, detailPaneBody, closeDetailPaneHandler } = props;

  const getHeaderDetails = () => {
    return React.cloneElement(detailPaneHeader, {
      closeDetailPaneHandler
    });
  };

  return (
    <>
      {getHeaderDetails()}
      {detailPaneBody}
    </>
  );
};

export const DetailPaneContainer: React.FC<DetailPaneContainerProps> =
  props => {
    return <>{props.children}</>;
  };
